import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from '../../../configuration/edit/ColorPicker';
import Ranges from '../../../../system/ranges';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import {
  IFTTTIntegrationEventNameFeatureDescription,
  IFTTTIntegrationKeyFeatureDescription,
} from '../../../../system/FeatureDescriptionModal';
import {MessageAlert} from '../../utils';

let DataForVariable2Type = {
  RawText: {
    title: 'Text',
    defaultValue: 'SomeText',
    input: (range, onRangeChange) => {
      return (
        <input
          value={range.value}
          onChange={(e) =>
            onRangeChange({
              ...range,
              value: e.target.value,
            })
          }
        />
      );
    },
  },
  ColorWithHex: {
    title: 'Color (Hex code)',
    defaultValue: '#11a2b1',
    input: (range, onRangeChange) => {
      return (
        <ColorPicker
          color={range.value}
          onChangeComplete={(value) =>
            onRangeChange({
              ...range,
              value,
            })
          }
        />
      );
    },
  },
  /*
     , ColorWithoutHex: {
        title: "Color (Hex code without #)",
        defaultValue: "ad13b2",
        input: (range, onRangeChange) => {
            return <input value={range.value}
                          onChange={e => onRangeChange({
                              ...range,
                              value: e.target.value
                          })}
            />
        }
        }
     */
};

export const IFTTTIntegrationV2 = ({
  onConfigUpdate,
  validateAndGet,
  configuration,
}) => {
  useEffect(() => {
    validateAndGet(() => {
      return true;
    });
  }, []);

  const [eventNameError, setEventNameError] = useState(undefined);

  const [keyError, setKeyError] = useState(undefined);

  useEffect(() => {
    validateAndGet(() => {
      let isValid = true;

      if (
        configuration.eventName === undefined ||
        configuration.eventName === ''
      ) {
        setEventNameError('Event name should not be empty');
        isValid = false;
      }

      if (configuration.key === undefined || configuration.key === '') {
        setKeyError('Key should not be empty');
        isValid = false;
      }

      return isValid;
    });
    // eslint-disable-next-line
  }, [configuration]);

  let defaultRange = {
    from: 60,
    to: 91,
    value:
      DataForVariable2Type[resolveVariable2Type(configuration)].defaultValue,
  };

  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Event name {<IFTTTIntegrationEventNameFeatureDescription />}
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="input"
            value={configuration.eventName}
            onChange={(e) => {
              onConfigUpdate({...configuration, eventName: e.target.value});
              setEventNameError(undefined);
            }}
          />
        </Col>
      </Form.Group>

      <MessageAlert message={eventNameError} />
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Key {<IFTTTIntegrationKeyFeatureDescription />}
        </Form.Label>
        <Col sm="3">
          <Form.Control
            as="input"
            value={configuration.key}
            onChange={(e) => {
              onConfigUpdate({...configuration, key: e.target.value});
              setKeyError(undefined);
            }}
          />
        </Col>
      </Form.Group>

      <MessageAlert message={keyError} />

      <BasicFormElement label={'Fire frequency'}>
        <Row>
          <Col md={'auto'} className={'align-vertical-center'}>
            Up to
          </Col>
          <Col md={'2'}>
            {' '}
            <Form.Control
              type={'number'}
              min={0}
              max={10}
              value={configuration.frequency.times}
              onChange={(e) => {
                let parsed = parseInt(e.target.value);
                if (!isNaN(parsed) && parsed <= 10 && parsed > 0) {
                  onConfigUpdate({
                    ...configuration,
                    frequency: {...configuration.frequency, times: parsed},
                  });
                }
              }}
            />
          </Col>
          <Col md={'auto'} className={'align-vertical-center'}>
            time(s) per{' '}
          </Col>
          <Col md={'2'}>
            {' '}
            <Form.Control
              type={'number'}
              min={0}
              max={10}
              value={moment
                .duration(configuration.frequency.duration)
                .asMinutes()}
              onChange={(e) => {
                let parsed = parseInt(e.target.value);
                if (!isNaN(parsed) && parsed <= 10 && parsed > 0) {
                  onConfigUpdate({
                    ...configuration,
                    frequency: {
                      ...configuration.frequency,
                      duration: moment
                        .duration(parsed, 'minutes')
                        .toISOString(),
                    },
                  });
                }
              }}
            />
          </Col>
          <Col md={'auto'} className={'align-vertical-center'}>
            minute(s){' '}
          </Col>
        </Row>
      </BasicFormElement>

      <BasicFormElement label={'{{Value1}}'}>
        <Row>
          <Col md={'auto'} className={'align-vertical-center'}>
            BPM value{' '}
          </Col>
        </Row>
      </BasicFormElement>
      <BasicFormElement label={'{{Value2}}'}>
        <select
          value={resolveVariable2Type(configuration)}
          onChange={(event) => {
            let ranges = cloneDeep(configuration.ranges).map((range) => {
              return {
                ...range,
                value: DataForVariable2Type[event.target.value].defaultValue,
              };
            });

            onConfigUpdate({
              ...configuration,
              metadata: {
                ...(configuration.metadata ? configuration.metadata : {}),
                variable2Type: event.target.value,
              },
              ranges,
            });
          }}
        >
          {Object.keys(DataForVariable2Type).map((key, index) => (
            <option key={index} value={key}>
              {DataForVariable2Type[key].title}
            </option>
          ))}
        </select>
      </BasicFormElement>

      <h3>Configure ranges for {'{{Variable2}}'}</h3>
      <Ranges
        ranges={configuration.ranges}
        onRangesChange={(ranges) => onConfigUpdate({...configuration, ranges})}
        defaultRange={defaultRange}
        header={
          <Col md={3}>
            <Form inline>
              <Col>
                {
                  DataForVariable2Type[resolveVariable2Type(configuration)]
                    .title
                }
              </Col>
            </Form>
          </Col>
        }
        rangeConfiguration={(range, onRangeChange) => {
          return (
            <Col md={3} key={range.from}>
              <Form inline>
                {DataForVariable2Type[
                  resolveVariable2Type(configuration)
                ].input(range, onRangeChange)}
              </Form>
            </Col>
          );
        }}
      />
      <Row className={'pt2'}>&nbsp;</Row>
    </>
  );
};

const resolveVariable2Type = (configuration) =>
  configuration.metadata ? configuration.metadata.variable2Type : 'RawText';

const BasicFormElement = ({label, children}) => {
  return (
    <Form.Group as={Row}>
      <Form.Label column sm="2">
        {label}
      </Form.Label>
      <Col sm="8">{children}</Col>
    </Form.Group>
  );
};
